import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'

export default class {
  @observable data = {
    tag: 1,
    user: {
      uid: 0,
      token: ''
    },
    userInfo: {},
    nowgold: 0,
    sendman: {
      uid: -1,
      duid: -1,
      nickname: '',
      agent: 2,
      avatarurl: 'https://img.chatie.live/app/man.jpg'
    },
    list: [],
    goldList: [
      {
        gold: 1000,
        price: 1
      },
      {
        gold: 10000,
        price: 10
      },
      {
        gold: 50000,
        price: 50
      },
      {
        gold: 75000,
        price: 75
      },
      {
        gold: 105000,
        price: 100
      },
      {
        gold: 210000,
        price: 200
      },
      {
        gold: 315000,
        price: 300
      },
      {
        gold: 525000,
        price: 500
      },
      {
        gold: 1050000,
        price: 1000
      },
      {
        gold: 5250000,
        price: 5000
      },
      {
        gold: 10500000,
        price: 10000
      }
    ]
  }

  @action async dataInit() {
    this.data.sendman = {
      uid: -1,
      duid: -1,
      nickname: '',
      avatarurl: 'https://img.chatie.live/app/man.jpg'
    }
  }

  @action async setTag(tag) {
    this.data.tag = tag
  }

  @action async setRecUid(d) {
    console.log(d)
    if (d && d.code == 0 && d.res) {
      console.log(d)
      this.data.sendman = d.res
    } else {
      this.data.sendman = {
        uid: 0,
        duid: 0,
        nickname: '',
        avatarurl: 'https://img.chatie.live/app/man.jpg'
      }
    }
  }

  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  @action async MyAccountInfo() {
    let d = await http.post('/web/MyAccountInfo', {})
    this.data.userInfo = d.res
    this.data.nowgold = d.res.agentGold || 0
    // console.log("22222 this.data.nowgold", this.data.nowgold)
    d = await http.post('/web/UserExtendRecordList', {})
    this.setList(d)
  }

  @action async setList(d) {
    if (d && d.code == 0 && d.res.list && d.res.list.length > 0) {
      let newList = []
      let list = d.res.list
      for (let i = 0; i < list.length; i++) {
          newList.push(list[i])
      }
      this.data.list = newList
    } else {
      this.data.list = []
    }
  }

  @action async setUidGold(d) {
    if (d && d.code == 0 && d.res.length > 0) {
      this.data.nowgold = d.res[0].val
    } else {
      this.data.nowgold = 0
    }
  }
}



// WEBPACK FOOTER //
// src/store/app/agentgold.js